<template>
    <header>
        <top-bar />

        <div class="row no-gutter">
            <div class="col-auto top-info-container">
                <top-info />
            </div>

            <div class="col">
                <nav-bar />
            </div>
        </div>
    </header>

    <main>
        <div class="row default-layout-row">
            <slot />
        </div>
    </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NavBar from '@/components/NavBar.vue';
import TopBar from '@/components/TopBar.vue';
import TopInfo from '@/components/TopInfo.vue';

export default defineComponent({
    components: {
        NavBar,
        TopBar,
        TopInfo,
    },

    setup() {
        return {};
    },
})
</script>

<style lang="scss" scoped>

main {
    display: flex;
    flex-direction: column;
    padding-top: 1rem;
}

main, main > .row {
    flex-grow: 1;
}

.top-info-container {
    min-width: 15vw;    // 15% of the window width
    max-width: 30vw;
}

</style>

<style lang="scss"> // Unscoped styles for the generic layout and its direct children

.default-layout-row {
    & > .form-area {
        @include media-breakpoint-up(lg) {
            width: 40%;
            min-width: 570px;
        }
    }

    & > .data-area {
        overflow: hidden;
    }
}

</style>
